module.exports = __webpack_public_path__ + "img/72.1cbe3a4.png";